import {Dispatch, SetStateAction, useMemo, useState} from "react";


export interface UploadState {
    uploading: boolean,
    done: boolean,
    progress: number,
    error: string | undefined,
}

const _initialUploadState: UploadState = {
    uploading: false,
    done: false,
    progress: 0,
    error: undefined,
};

/**
 * A hook to manage the upload state.
 *
 * @template T              The type of the upload state.
 * @param initialState      The initial state of the upload state.
 * @returns                 The upload state, the function to set the upload state, and the initial upload state.
 */
const useUploadState = <T extends UploadState = UploadState>(initialState?: Partial<T>): [T, Dispatch<SetStateAction<T>>, T] => {
    const initialUploadState = useMemo<T>(() => ({..._initialUploadState, ...(initialState ?? {})}) as T, [initialState]);
    const [uploadState, setUploadState] = useState<T>(initialUploadState);

    return [uploadState, setUploadState, initialUploadState];
}

export default useUploadState;
